import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var chip = createRuntimeFn({defaultClassName:'fx_e395032e_1vsx1ym3',variantClassNames:{size:{'default':'fx_e395032e_1vsx1ym4',large:'fx_e395032e_1vsx1ym5'},state:{'default':'fx_e395032e_1vsx1ym6',error:'fx_e395032e_1vsx1ym7'}},defaultVariants:{size:'default',state:'default'},compoundVariants:[]});

export { chip };
//# sourceMappingURL=chip.vanilla.mjs.map
